import { ConnectionPartner } from 'support/types';

export const getLatestTradeRequestDate = (partner: ConnectionPartner): string | null => {
  const allRelationships = [...(partner.sender_relationships || []), ...(partner.receiver_relationships || [])];

  const dates = allRelationships
    .map((r) => r.trade_request?.created_at)
    .filter((date): date is string => Boolean(date));

  if (dates.length === 0) {
    return null;
  }

  return dates.reduce((latest, current) => (new Date(current) > new Date(latest) ? current : latest));
};
